import dayjs, { Dayjs } from "dayjs";

// Generates a start and end date range based on a given period.

const generateDateRange = (selectedDatePeriod: string): { start?: string; end?: string } => {
  const today = dayjs();
  let start: Dayjs | null = null;
  let end: Dayjs | null = null;

  switch (selectedDatePeriod) {
    case "Last 7 Days":
      start = today.subtract(7, "day");
      end = today;
      break;
    case "Last 30 Days":
      start = today.subtract(30, "day");
      end = today;
      break;
    case "Last 90 Days":
      start = today.subtract(90, "day");
      end = today;
      break;
    case "Last Month":
      start = today.subtract(1, "month").startOf("month");
      end = today.subtract(1, "month").endOf("month");
      break;
    case "Last Year":
      start = today.subtract(1, "year").startOf("year");
      end = today.subtract(1, "year").endOf("year");
      break;
    case "Last Quarter":
      const currentQuarter = Math.floor((today.month() + 3) / 3);
      start = today
        .subtract(1, "year")
        .month((currentQuarter - 2) * 3)
        .startOf("month");
      end = start.add(2, "month").endOf("month");
      break;
    case "MTD":
      start = today.startOf("month");
      end = today;
      break;
    case "QTD":
      const quarter = Math.floor((today.month() + 3) / 3);
      start = today.month((quarter - 1) * 3).startOf("month");
      end = today;
      break;
    case "YTD":
      start = today.startOf("year");
      end = today;
      break;
    case "Custom":
      // Handle custom date range if needed
      start = null;
      end = null;
      break;
    case "All time":
    default:
      start = null;
      end = null;
  }

  return {
    start: start ? start.format("YYYY-MM-DD") : undefined,
    end: end ? end.format("YYYY-MM-DD") : undefined,
  };
};

export default generateDateRange;